import { EntityRepository, Repository } from "typeorm";
import { VendorsPriceList } from "../entities/vendor-price-list.entity";

@EntityRepository(VendorsPriceList)
export class VendorsPriceListRepository extends Repository<VendorsPriceList> {

}